module.exports = __webpack_public_path__ + "img/einstellungen.2cef5dc8.svg";